/* eslint-disable react/jsx-no-bind */
/* eslint-disable import/no-unresolved */
/* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/no-unsafe-argument, max-params */
/* eslint-disable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any */
/* eslint-disable complexity, @typescript-eslint/no-unsafe-call */
/* eslint-disable no-unused-vars, @typescript-eslint/no-unsafe-member-access  */
/* eslint-disable @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-assignment  */
/* tslint:disable */
// @ts-nocheck
// What's with all the above disables?
//  this is what a legacy 7 year old codebase looks like.

import React from 'react';
import { PropTypes, describe } from '@elliemae/ds-props-helpers';
import { Grid } from '@elliemae/ds-grid';
import { styled, withTheme } from '@elliemae/ds-system';
import { ToolbarItem } from './MobileActionToolbarItem.js';

const ToolStrip = styled(Grid)`
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: ${(props) => props.theme.colors.neutral['000']};
`;
const Toolbar = ({ withDepth = true, buttons = [], theme }) => {
  const rows = [1];
  const toolbarHeight = theme.space.m;
  const borderStyle = withDepth ? { boxShadow: '0 1px 5px 0 rgba(0,0,0,0.5)' } : { boxShadow: 'none' };
  return (
    <ToolStrip rows={rows} height={toolbarHeight} style={borderStyle}>
      {buttons}
    </ToolStrip>
  );
};

const props = {
  /** toggle box shadow for buttons border */
  withDepth: PropTypes.bool.description('toggle box shadow for buttons border'),
  /** button array for the mobile action toolbar */
  buttons: PropTypes.arrayOf(PropTypes.element).description('button array for the mobile action toolbar'),
};

const DSMobileActionToolbar = withTheme(Toolbar);
DSMobileActionToolbar.displayName = 'DSMobileActionToolbar';
const DSMobileActionToolbarWithSchema = describe(DSMobileActionToolbar);
DSMobileActionToolbarWithSchema.propTypes = props;

export { DSMobileActionToolbar, ToolbarItem, DSMobileActionToolbarWithSchema };
// export default DSMobileActionToolbar;
